import React, { useState } from "react";
import { Container, Form, Button, Row, Col, Alert } from "react-bootstrap";

const EntrepriseContactPage = () => {
  const [formData, setFormData] = useState({
    nom: "",
    entreprise: "",
    email: "",
    message: "",
  });

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess(false);
    setError("");
  
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/email/contact-entreprise`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData?.error || "Échec de l'envoi.");
      }
  
      setSuccess(true);
      setFormData({ nom: "", entreprise: "", email: "", message: "" });
    } catch (err) {
      console.error("Erreur formulaire entreprise :", err);
      setError("Une erreur est survenue. Veuillez réessayer.");
    }
  };
  

  return (
    <Container className="mt-5 mb-5">
      <h2 className="text-center mb-4">Demande de Contact - Offre Entreprise</h2>
      <p className="text-center">
        Vous êtes une entreprise ? Parlons ensemble de vos besoins spécifiques.
        Remplissez le formulaire ci-dessous et nous vous contacterons rapidement.
      </p>

      <Row className="justify-content-center">
        <Col md={8}>
          {success && (
            <Alert variant="success">
              Merci pour votre message. Nous vous contacterons sous peu.
            </Alert>
          )}
          {error && <Alert variant="danger">{error}</Alert>}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Nom complet</Form.Label>
              <Form.Control
                type="text"
                name="nom"
                value={formData.nom}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Nom de l’entreprise</Form.Label>
              <Form.Control
                type="text"
                name="entreprise"
                value={formData.entreprise}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email professionnel</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Message</Form.Label>
              <Form.Control
                as="textarea"
                name="message"
                rows={5}
                value={formData.message}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <div className="text-center">
              <Button type="submit" variant="primary">
                Envoyer ma demande
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default EntrepriseContactPage;
